import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type PageHeaderBackButtonProps = Pick<TouchTargetProps, 'behavior'>;

const PageHeaderBackButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.6577 15.0312L3.95766 8.33125C3.91412 8.28777 3.87958 8.23614 3.85601 8.1793C3.83244 8.12246 3.82031 8.06153 3.82031 8C3.82031 7.93847 3.83244 7.87754 3.85601 7.8207C3.87958 7.76386 3.91412 7.71223 3.95766 7.66875L10.6577 0.96875"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PageHeaderBackButton: React.FC<PageHeaderBackButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.back()}
      icon={<PageHeaderBackButtonIcon />}
      behavior={behavior}
      typographyClassName="hidden min-[1700px]:inline text-bold"
    />
  );
};
